const inventoryTag = state => {
  return state.inventories_without_pagination.filter(
    inventory => inventory.inventory_type == 1
  );
};

const inventoryChip = state => {
  return state.inventories_without_pagination.filter(
    inventory => inventory.inventory_type == 2
  );
};

const inventoryCollar = state => {
  return state.inventories_without_pagination.filter(
    inventory => inventory.inventory_type == 3
  );
};

let getters = {
  inventoryTag,
  inventoryChip,
  inventoryCollar
};

export default getters;
